import { AfterViewInit, Component, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DiaryInterface } from 'src/app/models/interface/diary.interface';
import { LessonPreviewComponent } from '../../questionnaire/lesson-preview/lesson-preview.component';

export type DialogInterventionDiaryPreviewData = {
  diary: DiaryInterface;
};

@Component({
  selector: 'app-dialog-intervention-diary-preview',
  templateUrl: './dialog-intervention-diary-preview.component.html',
  styleUrls: ['./dialog-intervention-diary-preview.component.scss'],
})
export class DialogInterventionDiaryPreviewComponent implements OnInit, AfterViewInit {
  @ViewChild('lessonPreviewContainer', { read: ViewContainerRef }) lessonPreviewContainer: ViewContainerRef;

  public components: LessonPreviewComponent[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogInterventionDiaryPreviewData) {}

  ngOnInit(): void {
    this.components = [];
    if (this.lessonPreviewContainer) {
      this.lessonPreviewContainer.clear();
    }
  }

  ngAfterViewInit(): void {
    const component = this.lessonPreviewContainer.createComponent(LessonPreviewComponent).instance;
    const diary = this.data.diary;
    component._questionnaire_id = diary.attributes.questionnaire_id;
    component._isDiary = true;
    component._study_id = diary.attributes.study_id;
    component._diaryDefault = diary.attributes.page_color;
    component._diary = diary;
    this.components.push(component);
  }
}
